var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWemix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.666 3.061a14.015 14.015 0 0 1 5.365-1.06 14.03 14.03 0 0 1 13.646 10.733h-1.633a12.452 12.452 0 0 0-24.424 4.228h1.674l1.498-3.033a.874.874 0 0 1 1.635.185l1.161 4.901 1.166-6.84a.874.874 0 0 1 1.73.045l.982 8.504 1.531-13.07a.628.628 0 0 1 1.248.145L14.33 24.134a.862.862 0 0 1-.868.771.863.863 0 0 1-.868-.772l-1.052-9.11-1.032 6.054a.874.874 0 0 1-1.712.055l-1.35-5.698-1.132 2.294a.868.868 0 0 1-.784.487H2.176a14.16 14.16 0 0 1-.078-.566l-.001-.016a14.005 14.005 0 0 1-.047-.479l-.003-.029A13.987 13.987 0 0 1 2 16a14.016 14.016 0 0 1 8.666-12.938zm19.362 11.973v.007c.021.317.033.637.033.96a14.035 14.035 0 0 1-27.675 3.268h1.633A12.453 12.453 0 0 0 28.478 16c0-.323-.013-.642-.038-.96h-1.673l-1.499 3.034a.873.873 0 0 1-1.634-.185l-1.161-4.902-1.166 6.84a.874.874 0 0 1-1.73-.045l-.982-8.504-1.532 13.07a.628.628 0 0 1-1.249-.146l1.919-16.337a.863.863 0 0 1 .868-.771.863.863 0 0 1 .868.772l1.053 9.11 1.032-6.055a.873.873 0 0 1 1.713-.054l1.35 5.696 1.132-2.294a.87.87 0 0 1 .784-.486h3.357a14.27 14.27 0 0 1 .115.913v.004l.012.154.002.015.004.06.008.1z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWemix);
export default __webpack_public_path__ + "static/media/WEMIX.ac8dce2b6998469dc15a9d6374314457.svg";
export { ForwardRef as ReactComponent };